module.exports = __webpack_public_path__ + "static/media/Mar4-S19.7157a9af.png";